// Labels and signs for the order detail Price Breakdown (contract §5.3).

export const TOTAL_LABELS = {
  MRP_TOTAL: "MRP Total",
  ITEM_TOTAL: "Item Total",
  DISCOUNT_TOTAL: "Discount",
  MEMBERSHIP_DISCOUNT: "Membership Discount",
  OFFER_DISCOUNT: "Code Discount",
  FIXED_PLATFORM_FEE: "Platform Fee",
  TAX_TOTAL: "Tax",
  GRAND_TOTAL: "Grand Total",
};

/** Totals shown as "- INR x" in success colour (D59 adds membership). */
export const DISCOUNT_TYPES = new Set([
  "DISCOUNT_TOTAL",
  "MEMBERSHIP_DISCOUNT",
  "OFFER_DISCOUNT",
]);

export function getTotalLabel(type) {
  return TOTAL_LABELS[type] ?? type?.replace(/_/g, " ");
}

export function isDiscountTotal(type) {
  return DISCOUNT_TYPES.has(type);
}

/** "RUNFEST15, PACERS100" from `metadata.applied_codes`, or null when none. */
export function getAppliedCodesText(metadata) {
  const codes = (metadata?.applied_codes ?? [])
    .map((c) => c?.code)
    .filter(Boolean);
  return codes.length ? codes.join(", ") : null;
}

/**
 * Booking pricing "Code discount (RUNFEST15)" label, or null when the booking
 * has no code discount (D-10).
 */
export function getBookingCodeDiscountLabel(pricing) {
  if (!(Number(pricing?.code_discount) > 0)) return null;
  const codes = (pricing.codes ?? []).filter(Boolean);
  return codes.length ? `Code discount (${codes.join(", ")})` : "Code discount";
}

/**
 * Booking pricing "Total": `total_price` is the line total before codes (it keeps
 * today's meaning, D45), so a code discount is taken off here, as the card's
 * "Discount" row already is. Kept as `total_price` when the booking has no code.
 */
export function getBookingTotal(pricing) {
  if (pricing?.total_price == null) return null;
  const code = Number(pricing.code_discount);
  if (!(code > 0)) return pricing.total_price;
  return (Number(pricing.total_price) - code).toFixed(2);
}
